<template>
  <div>
    <!-- Vue tag to add header component -->
    <header-prismic/>
    <div class="container">
      <h1>Pagina niet gevonden</h1>
      <p>We konden de pagina die je geopend hebt helaas niet vinden. Onze excuses hiervoor.</p>
      <p><router-link to="/" style="text-decoration: underline;">Terug naar home</router-link></p>
    </div>
  </div>
</template>

<script>
import HeaderPrismic from '../components/HeaderPrismic.vue'

export default {
  name: 'NotFound',
  components: {
    HeaderPrismic
  }
}
</script>
